import type { AssetGroupId } from '@infinex/asset-config';

import type { SwidgeActivity } from '../types/index';

export function getSwidgeActivityAssetGroupId(
  activity: SwidgeActivity,
  options?: {
    useToAsset?: boolean;
  }
): AssetGroupId {
  return options?.useToAsset
    ? activity.toAssetId
      ? {
          assetId: activity.toAssetId,
        }
      : {
          address: activity.toAssetAddress,
          chain: activity.toChain,
        }
    : activity.fromAssetId
      ? {
          assetId: activity.fromAssetId,
        }
      : {
          address: activity.fromAssetAddress,
          chain: activity.fromChain,
        };
}
